export function KeyFeatures() {
    const features = [
        {
            icon: (
                <svg className="h-6 w-6 text-[#E81932]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"></path>
                </svg>
            ),
            title: 'Flight Services',
            description: 'Search flights, check real-time status, and access comprehensive flight information',
            bgColor: 'bg-[#E81932]/10'
        },
        {
            icon: (
                <svg className="h-6 w-6 text-[#60A5FA]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"></path>
                </svg>
            ),
            title: 'Booking Management',
            description: 'Retrieve bookings, check-in details, and comprehensive baggage information',
            bgColor: 'bg-[#60A5FA]/10'
        },
        {
            icon: (
                <svg className="h-6 w-6 text-[#22C55E]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    ></path>
                </svg>
            ),
            title: 'Travel Guides',
            description: 'Destination guides, current promotions, and curated travel information',
            bgColor: 'bg-[#22C55E]/10'
        },
        {
            icon: (
                <svg className="h-6 w-6 text-[#F59E0B]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
                </svg>
            ),
            title: 'Multi-Platform',
            description: 'Works with ChatGPT, Claude, VS Code Copilot, and other MCP-compatible hosts',
            bgColor: 'bg-[#F59E0B]/10'
        }
    ];

    return (
        <section className="mx-auto max-w-7xl px-4 py-12 sm:px-6 md:py-16 lg:px-8" aria-labelledby="features-heading">
            <h2 id="features-heading" className="mb-8 text-center text-3xl font-bold text-[#F8FAFC] md:text-4xl">
                Key Features
            </h2>
            <div className="grid gap-4 sm:grid-cols-2 md:gap-6 lg:grid-cols-4">
                {features.map((feature, index) => (
                    <article key={index} className="transform rounded-xl border border-[#374151] bg-[#2A2D35] p-5 transition-all duration-300 hover:-translate-y-1 hover:border-[#E81932] hover:shadow-lg hover:shadow-[#E81932]/10 md:p-6">
                        <div className={`h-12 w-12 ${feature.bgColor} mb-4 flex items-center justify-center rounded-lg`} aria-hidden="true">
                            {feature.icon}
                        </div>
                        <h3 className="mb-2 text-lg font-semibold text-[#F8FAFC]">{feature.title}</h3>
                        <p className="text-sm leading-relaxed text-[#CBD5E1]">{feature.description}</p>
                    </article>
                ))}
            </div>
        </section>
    );
}
